// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSCommunicationOption;
(function (TCSCommunicationOption) {
    TCSCommunicationOption[TCSCommunicationOption["Unspecified"] = 0] = "Unspecified";
    TCSCommunicationOption[TCSCommunicationOption["OptIn"] = 1] = "OptIn";
    TCSCommunicationOption[TCSCommunicationOption["OptOut"] = 2] = "OptOut";
})(TCSCommunicationOption || (TCSCommunicationOption = {}));
//# sourceMappingURL=tCSCommunicationOption.js.map